/**
 * ------------------------------------------------------------------
 * 微信企业号授权主入口文件
 * @author GLEN <zcslsf@gmail.com>
 * ------------------------------------------------------------------
 */

import WeChatAuth from './wechat-auth'
import url from 'url'
import querystring from 'querystring'
import config from '../../config/config';
import wxuserUtil from '../wxuserUtil';

export default {
  install (Vue, options) {
    let weChatAuth = new WeChatAuth(options)
    let router = options.router
    if (!router) return false

    function urlCodeQueryFilter (code) {
      if (code) {
        weChatAuth.setAuthCode(code)
        weChatAuth.removeUrlCodeQuery()
      }
    }

    /**
     * 检查路由权限,默认全部需要权限
     * meta : {
     *    noWxAuth : true //此种情况不需要授权
     * }
     * @param to
     * @param from
     * @param next
     * @returns {boolean}
     */
    function checkRouterAuth (to, from, next) {
      // weChatAuth.removeAuthCode();
      // weChatAuth.removeAccessToken();
      let authCode = weChatAuth.getAuthCode()
      if ((!to.meta || to.meta.noWxAuth) && !authCode) return true
      if (!authCode && !weChatAuth.getAccessToken()) {
        weChatAuth.openAuthPage(window.location.href,to);
        return false
      } else if (authCode && !weChatAuth.getAccessToken()) {
        weChatAuth.getCodeCallback(to,from,next)
        return false
      }

      return true
    }

    function beforeEach (to, from, next) {
      let query = querystring.parse(url.parse(window.location.href).query)
      let code = query.code
      urlCodeQueryFilter(code)
      var authFlag = checkRouterAuth(to, from, next);
      if (!code && !authFlag) {
        return false
      }
      next()
    }

    router.beforeEach((to, from, next) => {
      beforeEach(to, from, next);
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/wxwork-auth/index.js